import { SVGProps, Ref, forwardRef } from 'react';

export const HeadsetFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M11.093 3.326c-.6-.833-1.558-1.426-3.095-1.426-1.547 0-2.504.576-3.098 1.382-.618.838-.9 2.006-.9 3.25h-.001v6.132a5.6 5.6 0 0 1-1.4-.168C1.161 12.124 0 11.093 0 8.998S1.161 5.872 2.599 5.5l.06-.015c.128-1.085.467-2.156 1.114-3.034C4.653 1.257 6.046.5 7.998.5c1.963 0 3.355.79 4.231 2.008.625.868.963 1.916 1.099 2.975l.069.017c1.438.372 2.599 1.403 2.599 3.498s-1.161 3.126-2.6 3.498a5 5 0 0 1-.265.06 2.56 2.56 0 0 1-.746.93c-.625.492-1.502.754-2.618.807-.065.206-.167.41-.32.593-.339.407-.843.617-1.449.617s-1.11-.21-1.449-.617c-.32-.383-.417-.854-.417-1.25 0-.395.097-.866.417-1.25.339-.406.843-.616 1.449-.616s1.11.21 1.449.616c.131.158.225.33.29.507.924-.049 1.471-.262 1.783-.507.298-.234.454-.556.477-.997V6.41c-.032-1.162-.317-2.268-.904-3.083"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HeadsetFilledSize16Glyph.displayName = 'HeadsetFilledSize16Glyph';
